import { render, staticRenderFns } from "./time-activities-percentage.vue?vue&type=template&id=5bf19a1a&scoped=true&"
import script from "./time-activities-percentage.vue?vue&type=script&lang=js&"
export * from "./time-activities-percentage.vue?vue&type=script&lang=js&"
import style0 from "./time-activities-percentage.vue?vue&type=style&index=0&id=5bf19a1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf19a1a",
  null
  
)

component.options.__file = "time-activities-percentage.vue"
export default component.exports